import { makeStyles } from "@material-ui/styles";

export default makeStyles(theme => ({
  disabled: {
    "&:before": {
      borderColor: "transparent !important"
    }
  },
  underline: {
    "&:hover:not($disabled):before,&:before": {
      borderColor: "#D2D2D2 !important",
      borderWidth: "1px !important"
    },
    "&:after": {
      borderColor: theme.palette.info.main
    }
  },
  underlineError: {
    "&:after": {
      borderColor: theme.palette.danger.main
    }
  },
  underlineSuccess: {
    "&:after": {
      borderColor: theme.palette.success.main
    }
  },
  whiteUnderline: {
    "&:hover:not($disabled):before,&:before": {
      borderColor: "#FFFFFF"
    },
    "&:after": {
      borderColor: "#FFFFFF"
    }
  },
  labelRoot: {
    color: "#AAAAAA !important",
    fontWeight: "400",
    fontSize: "18px",
    lineHeight: "1.42857",
    top: "10px",
    letterSpacing: "unset",
    "& + $underline": {
      marginTop: "0px"
    }
  },
  labelRootError: {
    color: theme.palette.danger.main + " !important"
  },
  labelRootSuccess: {
    color: theme.palette.success.main + " !important"
  },
  helperLabelRoot: {
    color: "#AAAAAA",
    fontWeight: "400",
    fontSize: "13px",
  },
  helperLabelError: {
    color: theme.palette.danger.main + " !important"
  },
  helperLabelSuccess: {
    color: theme.palette.success.main + " !important"
  },
  icon: {
    width: "14px",
    height: "14px",
    marginRight: "3px",
    marginTop: "5px",
    color: "#AAAAAA"
  },
  formControl: {
    margin: "0 0 17px 0",
    paddingTop: "27px",
    position: "relative",
    "& svg,& .fab,& .far,& .fal,& .fas,& .material-icons": {
      color: "#495057"
    }
  },
  input: {
    color: "#495057",
    height: "unset",
    "&,&::placeholder": {
      fontSize: "14px",
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      fontWeight: "400",
      lineHeight: "1.42857",
      opacity: "1"
    },
    "&::placeholder": {
      color: "#AAAAAA"
    }
  },
  whiteInput: {
    "&,&::placeholder": {
      color: "#FFFFFF",
      opacity: "1"
    }
  }
}));